import { createContext, type ReactNode, use } from "react";
import type { TableContextType } from "./types";

const TableContext = createContext<TableContextType<any> | undefined>(
  undefined,
);

export function TableContextProvider<Item>({
  value,
  children,
}: {
  value: TableContextType<Item>;
  children: ReactNode;
}) {
  return <TableContext value={value}>{children}</TableContext>;
}

export function useTableContext<Item>() {
  const context = use(TableContext);
  if (!context) {
    throw new Error("useTableContext must be used within TableContextProvider");
  }
  return context as TableContextType<Item>;
}
